import React from 'react';

const TimerDollar = ({ width = 38, height = 38, color = "black" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 38 38" 
      fill="none"
    >
      <g clipPath="url(#clip0_4979_7460)">
        <mask 
          id="mask0_4979_7460" 
          style={{ maskType: 'luminance' }} 
          maskUnits="userSpaceOnUse" 
          x="0" 
          y="0" 
          width="38" 
          height="38"
        >
          <path d="M0 3.8147e-06H38V38H0V3.8147e-06Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_4979_7460)">
          <path 
            d="M20.1915 32.4297H1.11328" 
            stroke={color} 
            strokeWidth="2" 
            strokeMiterlimit="10" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M3.33984 32.4297C3.33984 22.2133 10.0937 19.6886 10.0937 16.7695C10.0937 13.8505 3.33984 11.393 3.33984 1.10938" 
            stroke={color} 
            strokeWidth="2" 
            strokeMiterlimit="10" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M21.2266 1.10477C21.2266 11.3211 14.5469 13.8459 14.5469 16.7649C14.5469 18.7511 17.6393 20.5634 19.6159 24.7109" 
            stroke={color} 
            strokeWidth="2" 
            strokeMiterlimit="10" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M11.6296 10.6814C11.224 10.2052 10.775 9.68112 10.3271 9.07884C9.6563 8.17537 8.97787 7.02157 8.50391 5.55827H16.1175C15.3847 7.78045 14.1475 9.31916 13.0092 10.6673C12.7809 10.9379 12.5471 11.2141 12.3167 11.5C12.0873 11.2195 11.8557 10.9477 11.6296 10.6814Z" 
            stroke={color} 
            strokeWidth="2" 
            strokeMiterlimit="10" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M1.11328 1.10938H23.4531" 
            stroke={color} 
            strokeWidth="2" 
            strokeMiterlimit="10" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M26.199 30.8301C27.5957 31.8776 30.2653 31.136 30.2653 29.6493C30.2653 27.1848 25.5469 28.7739 25.5469 26.3094C25.5469 24.8161 28.2209 24.0844 29.6131 25.1286" 
            stroke={color} 
            strokeWidth="2" 
            strokeMiterlimit="10" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M27.9062 32.5781V31.3164" 
            stroke={color} 
            strokeWidth="2" 
            strokeMiterlimit="10" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M27.9062 24.6328V23.3711" 
            stroke={color} 
            strokeWidth="2" 
            strokeMiterlimit="10" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
          <path 
            d="M36.8867 27.9766C36.8867 32.8953 32.825 36.8828 27.9062 36.8828C22.9875 36.8828 19 32.8953 19 27.9766C19 23.0578 22.9875 19.0703 27.9062 19.0703C32.825 19.0703 36.8867 23.0578 36.8867 27.9766Z" 
            stroke={color} 
            strokeWidth="2" 
            strokeMiterlimit="10" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4979_7460">
          <rect width="38" height="38" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default TimerDollar;